import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const Cancel = () => {
  return (
    <main data-testid="page-cancel" className="max-w-3xl mx-auto px-6 lg:px-10 py-24 text-center">
      <div className="glass rounded-3xl p-12 border border-white/10 flex flex-col items-center gap-4">
        <XCircle className="w-14 h-14 text-[#ff1a8c]" />
        <h1 className="font-script text-6xl neon-gradient-text">Checkout cancelled</h1>
        <p className="text-gray-400 max-w-md">
          No charge was made. Your cart is still waiting whenever you're ready.
        </p>
        <div className="flex flex-wrap gap-4 justify-center mt-4">
          <Link to="/shop" data-testid="cancel-back-shop" className="neon-btn neon-btn--blue">Back to shop</Link>
          <Link to="/" data-testid="cancel-back-home" className="neon-btn">Home</Link>
        </div>
      </div>
    </main>
  );
};

export default Cancel;
